import { render, staticRenderFns } from "./cancelOrderDialog.vue?vue&type=template&id=8c8ccbfa&scoped=true"
import script from "./cancelOrderDialog.vue?vue&type=script&lang=js"
export * from "./cancelOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./cancelOrderDialog.vue?vue&type=style&index=0&id=8c8ccbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8ccbfa",
  null
  
)

export default component.exports